import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { ConnectedProps } from 'mf-shared/types/common';

import styles from './style.css';

function mapStateToProps(state) {
  return {
    data: state,
  };
}

const connector = connect(mapStateToProps);

interface SuccessForgotPasswordProps {}

type Props = ConnectedProps<typeof connector, SuccessForgotPasswordProps>;

function SuccessForgotPassword({ data }: Props) {
  const { changeBy } = data.forgotPassword;

  return (
    <div className="container">
      <div className="row">
        <div className={`${styles.content}`}>
          <div className={`${styles.image}`}>
            <img
              src={`${
                changeBy === 'email'
                  ? 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/email.svg'
                  : 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/lock.svg'
              }`}
              alt="email"
            />
          </div>
          {changeBy === 'email' && <h2>Check Your Email</h2>}
          {changeBy === 'phone' && (
            <h2>
              Your password has been
              <br />
              changed successfully.
            </h2>
          )}
          {changeBy === 'email' && (
            <p>A link to reset your password has been sent to your email.</p>
          )}
          <Link to="/login" className={`${styles.loginBtn}`}>
            Back to Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}

export default connector(SuccessForgotPassword);
